var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire","dark":""}},[_c('main',[_c('v-content',[_c('div',{attrs:{"id":"NotFound"}},[_c('h1',[_vm._v(" Not Found :( ")])])])],1),_vm._v(" "),_c('v-footer',{attrs:{"app":"","fixed":""}},[_c('span',[_vm._v("© 2017")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c7711d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/notFound.vue
// module id = n0g9
// module chunks = 2